import { useMutation, useQueryClient } from "react-query";

import { favouriteItemsKey } from "../../queries";
import { addFavourite } from "./addFavourite.fetcher";
import { AddFavouriteMutationResult } from "./addFavourite.types";

export function useAddFavouriteMutation(): AddFavouriteMutationResult {
  const queryClient = useQueryClient();

  return useMutation(addFavourite, {
    onSettled: () => {
      queryClient.invalidateQueries(favouriteItemsKey);
    },
  });
}
